import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'

import { compliancesClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpdateNonCompliances($inputs: [NonComplianceInput]) {
    updateNonCompliances(inputs: $inputs) {
      id
      status
    }
  }
`

export const useChangeStatusNonCompliance = () => {
  const notify = useNotification()
  const modal = useAlert()

  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['NonCompliances', 'NonCompliance'],
    client: compliancesClient
  })

  const handleRequest = (ids, status) => {
    if (!modal.confirm({ title: 'Certeza que deseja aleterar o status?' })) return false
    const inputs = ids.map(id => ({ id, status }))

    return request({ variables: { inputs } }).then(resp => {
      if (!!resp.errors) {
        const foundDuplicatedKeyError = resp.errors?.find(
          error => error.message === 'duplicate key value violates unique constraint "unique_non_compliance_index"'
        )
        if (!!foundDuplicatedKeyError) {
          notify.error({ title: 'Já existe uma não conformidade para esta pergunta e neste local.' })
          return
        }
        notify.error({ title: 'Ocorreu um erro ao alterar o status!' })
      }
    })
  }

  return [handleRequest, state]
}
